import React from 'react';
import { Name } from '../general/name';
import { useTranslate } from 'app/translations';
import { selfKey } from 'utilities/names';

const Style = {
    container: 'flex flex-wrap w-full',
};

export const Assignee = ({ actionType, historyData, user, isSelf }) => {
    const { _t } = useTranslate();
    const { before, after } = historyData;

    return (
        <div className={Style.container}>
            {actionType === 'assignee_add' ? (
                <p className="flex gap-1">{_t(selfKey('ticket.history.event.assignee.added', isSelf)).toLowerCase()}
                    <span className="text-primary-700">
                        <Name user={user} target={after} />
                    </span>
                </p>
                ) : actionType === 'assignee_rem' && (
                    <p className="flex gap-1">
                        {_t(selfKey('ticket.history.event.assignee.removed', isSelf)).toLowerCase()}
                        <span className="text-primary-700">
                            <Name user={user} target={before} />
                        </span>
                    </p>
                )
            }         
        </div>
    );
};
